import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/TippspielChevronRight.svg";

export function TippspielChevronRightIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
